module.exports = __webpack_public_path__ + "static/media/market-warrior.8ecadec5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/market-warrior.jpg
// module id = 2632
// module chunks = 0